import "@blocknote/mantine/style.css";
import "@blocknote/xl-ai/style.css";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  AmplifyBootstrap,
  AppBootstrapStatus,
} from "data/services/amplify/AmplifyBootstrap";
import { shouldRetryAuthentication } from "data/store/Auth";
import React from "react";
import ReactDOM from "react-dom/client";
import "ui/styles/index.css";
import { initDatadog } from "./datadog.ts";
import reportWebVitals from "./reportWebVitals";
import MainRouter from "./routes";

AmplifyBootstrap()
  .then((appBootstrapStatus: AppBootstrapStatus) => {
    if (appBootstrapStatus === AppBootstrapStatus.SUCCESS) {
      // Initialize Datadog RUM
      initDatadog();

      const root = ReactDOM.createRoot(
        document.getElementById("root") as HTMLElement,
      );

      root.render(
        <React.StrictMode>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MainRouter />
          </LocalizationProvider>
        </React.StrictMode>,
      );
    }
  })
  .catch((appBootstrapStatusError: Error) => {
    console.error(
      "Error initialzing the application.\n",
      appBootstrapStatusError,
      "\n",
      appBootstrapStatusError.cause,
    );

    if (shouldRetryAuthentication()) window.location.reload();
    else
      console.error("Stopped authentication process after 5 failed attempts.");
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
